module.exports = __webpack_public_path__ + "img/39_004_013.8a7c5692.png";